<template>
  <footer class="bg-gray-900 text-white pt-12 pb-8">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
        <!-- 解决方案与产品 -->
        <div class="text-center">
          <h3 class="text-lg sm:text-xl font-bold mb-4 sm:mb-6">解决方案与产品</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><router-link to="/carrier-network" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">运营商网络</router-link></li>
            <li><router-link to="/government-enterprise" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">政企解决方案</router-link></li>
            <li><router-link to="/consumer-terminal" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">消费者终端</router-link></li>
            <li><router-link to="/5g-technology" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">5G技术</router-link></li>
            <li><router-link to="/cloud-big-data" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">云计算与大数据</router-link></li>
          </ul>
        </div>
        <!-- 服务与支持 -->
        <div class="text-center">
          <h3 class="text-lg sm:text-xl font-bold mb-4 sm:mb-6">服务与支持</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><a href="#" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">技术支持</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">文档中心</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">常见问题</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">联系我们</a></li>
          </ul>
        </div>

         <!-- 关于chmura云 -->
        <div class="hidden md:block">
          <h3 class="text-lg sm:text-xl font-bold mb-4 sm:mb-6">关于云</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><router-link to="/about" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">公司简介</router-link></li>
            <li><router-link to="/about" class="text-gray-400 hover:text-white transition duration-300 text-sm sm:text-base">企业文化</router-link></li>
          </ul>
        </div>
        <!-- 联系我们 -->
        <div class="hidden md:block">
          <h3 class="text-lg sm:text-xl font-bold mb-4 sm:mb-6">联系我们</h3>
          <ul class="space-y-3 sm:space-y-4">
            <li class="flex flex-col sm:flex-row items-start">
              <i class="fas fa-map-marker-alt mt-1 mr-3 text-blue-400 flex-shrink-0"></i>
              <span class="text-gray-400 text-sm sm:text-base">江苏省苏州市姑苏区广济南路288号1003室</span>
            </li>
            <li class="flex items-center">
              <i class="fas fa-phone-alt mr-3 text-blue-400 flex-shrink-0"></i>
              <span class="text-gray-400 text-sm sm:text-base">400-96777-26</span>
            </li>
            <li class="flex items-center">
              <i class="fas fa-envelope mr-3 text-blue-400 flex-shrink-0"></i>
              <span class="text-gray-400 text-sm sm:text-base">4009677726@chmura.cn</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- Bottom legal links and copyright -->
      <div class="border-t border-gray-800 pt-6 sm:pt-8">
        <div class="flex flex-col  justify-between items-center">
          <!-- <div class="mb-4 md:mb-0">
            <img src="../assets/4.png" alt="chmura云" class="h-6 sm:h-8">
          </div> -->
          <div class="flex flex-wrap justify-end gap-3 sm:gap-4 text-xs sm:text-sm text-gray-400">
            <a href="#" class="hover:text-white transition duration-300">隐私政策</a>
            <a href="#" class="hover:text-white transition duration-300">使用条款</a>
            <a href="#" class="hover:text-white transition duration-300">法律声明</a>
          </div>
        </div>
        <p class="text-center text-gray-500 text-xs sm:text-sm mt-4">© 2026 云联网（江苏）通讯技术有限公司 版权所有</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
footer {
  margin-top: 2rem;
}
</style>